import { render, staticRenderFns } from "./SettingsMisc.vue?vue&type=template&id=15bf80eb&"
import script from "./SettingsMisc.vue?vue&type=script&lang=js&"
export * from "./SettingsMisc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/m3/deti-ekarta43-ru/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSubheader } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VIcon,VList,VProgressLinear,VSubheader,VSwitch})
